// Shared helpers for the absence / approval / entitlement pages.

// Business dates are Lisbon dates whatever the device timezone is.
export const lisbonToday = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Lisbon' });
export const lisbonYear = () => Number(lisbonToday().slice(0, 4));

// 'YYYY-MM-DD' -> '05 Jun 2026'. Parsed as UTC noon so no timezone can shift the day.
export function fmtDate(iso, lang) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00Z`);
  return d.toLocaleDateString(lang === 'en' ? 'en-GB' : 'pt-PT', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

export function fmtDateTime(ts, lang) {
  if (!ts) return '';
  return new Date(ts).toLocaleString(lang === 'en' ? 'en-GB' : 'pt-PT', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Lisbon',
  });
}

// Days are shown with at most one decimal (half days): 5 -> "5", 4.5 -> "4,5" / "4.5".
export function fmtDays(n, lang) {
  if (n === null || n === undefined) return '–';
  return Number(n).toLocaleString(lang === 'en' ? 'en-GB' : 'pt-PT', { maximumFractionDigits: 1 });
}

export const kindLabel = (r, lang) => (lang === 'en' ? r.kind_label : r.kind_label_pt) || r.kind || '';

export const apiMessage = (err, fallback) => err?.response?.data?.message || fallback;

// Days 22..26 in half-day steps (the legal minimum up to the company-agreement maximum).
export const ENTITLEMENT_DAYS = Array.from({ length: 9 }, (_, i) => 22 + i * 0.5);
